/* eslint-disable */
import Vue from 'vue';
// LONG LIVE ELEMENT!
import ElementUI from 'element-ui';
import App from './app.vue';
import router from './router';
import store from './store';
import ajax from './ajax';
import MD5 from 'spark-md5';
// import axios from 'axios';
// Ai Design
import AiDesign from './components/ai-design';

import 'material-design-icons/iconfont/material-icons.css';
import 'element-ui/lib/theme-chalk/index.css';
import './style/element-variables.scss';
import './style/style.scss';
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(VueAxios,axios);



Vue.config.productionTip = false;

Vue.use(ElementUI, { size: 'mini' });
Vue.prototype.$element = {};
Vue.prototype.$element.message = Vue.prototype.$message;
Vue.prototype.$element.confirm = Vue.prototype.$confirm;

Vue.use(AiDesign);

Vue.prototype.$http = ajax;

Vue.prototype.$log = console.log; // eslint-disable-line


Vue.prototype.$eventReport = async (para, extra) => { //用作数据上报
  try {
    const user = JSON.parse(window.localStorage.getItem('user')) || { user_id: 0, username: '' };
    if (extra) {
      para.data = user.username;
    }

    await ajax.post('https://ali-openfaas.aibee.cn/function/project-management/event_report', para); //线上 
  } catch (e) {
    console.log(e);
  }
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
